import React, { useState, useRef, useEffect } from "react";
import '../../../scss/TypeTracNghiem.scss'
import he from 'he';
import { ThiTrucTuyenService } from 'services/ThiTrucTuyenService';
import { Toast } from 'primereact/toast';
const TypeSelect = (props) => {
    const { data, onChangeValue, isNhom, userId, time, overview, thitructuyen } = props;
    const isExample = data?.is_example == 1;
    // Nếu là câu example, tự động chọn đáp án có is_example = 1
    const exampleAnswer = isExample ? data?.lstdapan?.find(item => item.is_example == 1) : null;
    const [selectedValue, setSelectedValue] = useState(
        isExample && exampleAnswer ? exampleAnswer.id : (data?.selected?.id_cautraloi || '')
    );
    const audioRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const toast = useRef(null);
    const IdDeThi = localStorage.getItem('IdDeThi');

    const toggleAudio = async () => {
        try {
            const el = audioRef.current;
            if (!el) return;

            const playCountKey = `playCount_${userId}_${data.id}_${IdDeThi}`;
            const currentCount = parseInt(localStorage.getItem(playCountKey) || '0');

            if (isPlaying) {
                el.pause();
                setIsPlaying(false);
            } else {
                if (currentCount >= 2) {
                    toast.current.show({
                        severity: 'warn',
                        summary: 'Thông báo',
                        detail: 'Bạn đã hết lượt nghe cho câu hỏi này (tối đa 2 lần).',
                        life: 3000
                    });
                    return;
                }

                // Nếu bắt đầu nghe (lượt 1 hoặc 2), thì nghe lại từ đầu
                el.currentTime = 0;
                await el.play();
                setIsPlaying(true);

                const newCount = currentCount + 1;
                localStorage.setItem(playCountKey, newCount);
            }
        } catch (e) {
            // ignore play error
        }
    };

    const containsUnderscore = data.vanbancauhoi.includes('___');
    const parts = containsUnderscore ? data.vanbancauhoi.split('___') : [data.vanbancauhoi];

    const handleChange = (event) => {
        if (isExample) return; // Không cho chọn đáp án khi là câu hỏi mẫu
        setSelectedValue(event.target.value);
        if (!isNhom) {
            onChangeValue(event.target.value);
        }
        onSubmitQuestion(data.id, event.target.value);
    }

    const onSubmitQuestion = async (idquestion, idanswer) => {
        const attemptCode = localStorage.getItem('exam_attempt_code');
        const typeExam = localStorage.getItem('typeExam');
        const IdDeThi = localStorage.getItem('IdDeThi');
        let body = {
            id_cauhoi: idquestion,
            id_cautraloi: idanswer,
            thoigianconlai: time,
            user_id: userId,
            loaibaithi: 1,
            attempt_code: attemptCode || null,
            dethitructuyen_id: IdDeThi,
            type_exam: typeExam
        }
        await ThiTrucTuyenService.submitquestion(body);
    }

    const selectedAnswer = data?.lstdapan?.find(item => String(item.id) === String(selectedValue));
    const isSelectedCorrect = selectedAnswer ? selectedAnswer.chinhxac == 1 : false;
    const showResultTick = overview && !isExample && selectedValue !== '' && selectedValue !== null && selectedValue !== undefined;


    return (
        <>
            <div className="conatiner-div1" style={{ height: 'auto' }}>


                {/* {data.des && (
                    <div
                        style={{
                            marginBottom: '16px',
                            padding: '14px 18px',
                            backgroundColor: '#f8f9fa',
                            borderRadius: '10px',
                            borderLeft: '4px solid #23085a',
                            fontSize: '14px',
                            lineHeight: '1.6',
                            color: '#333'
                        }}
                        dangerouslySetInnerHTML={{
                            __html: data.des
                        }}
                    />
                )} */}

                {data.vanbancauhoi.includes('___') ?
                    <>
                        {/* <div>
                            {data.file && data.file.includes('.mp3') &&
                                <div style={{
                                    padding: '12px',
                                    backgroundColor: '#fff',
                                    borderRadius: '10px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                                    marginBottom: '15px'
                                }}>
                                    <audio
                                        controlsList="nodownload"
                                        key={data.id}
                                        ref={audioRef}
                                        style={{ display: 'none' }}
                                        onEnded={() => setIsPlaying(false)}
                                    >
                                        <source src={data.file} type="audio/ogg" />
                                        <source src={data.file} type="audio/mpeg" />
                                    </audio>
                                    <button
                                        type="button"
                                        className="btn-audio-toggle"
                                        onClick={toggleAudio}
                                    >
                                        <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                        <span className="text">
                                            <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                        </span>
                                    </button>
                                </div>
                            }
                        </div> */}

                        <div className="d-flex">
                            <div className="mr-3" style={{ flex: 1 }}>
                                <div style={{
                                    padding: '16px 20px',
                                    fontSize: '15px',
                                    lineHeight: '2.2',
                                    color: '#333',
                                    display: 'flex',
                                    flexWrap: 'wrap',
                                    alignItems: 'center',
                                    gap: '4px',
                                }}>
                                    {isExample && (
                                        <span style={{
                                            display: 'inline-block',
                                            padding: '2px 10px',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffc107',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: '#856404',
                                            marginRight: '4px',
                                            verticalAlign: 'middle'
                                        }}>
                                            ⚡ Example
                                        </span>
                                    )}
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: he.decode(parts[0] || '').replace(/<\/?p[^>]*>/gi, '')
                                        }}
                                    />
                                    {data.vanbancauhoi.includes('___') && (
                                        <select
                                            style={{
                                                cursor: isExample ? 'not-allowed' : (!overview ? "pointer" : "default"),
                                                padding: '6px 10px',
                                                border: isExample ? '2px solid #f59e0b' : '2px solid #d0d7de',
                                                borderRadius: '8px',
                                                backgroundColor: isExample ? '#fef3c7' : '#fff',
                                                fontSize: '14px',
                                                color: isExample ? '#92400e' : '#333',
                                                fontWeight: isExample ? '700' : '500',
                                                outline: 'none',
                                                transition: 'all 0.2s ease',
                                                minWidth: '150px',
                                            }}
                                            value={selectedValue}
                                            onChange={handleChange}
                                            disabled={overview || isExample}
                                            onFocus={(e) => {
                                                if (!overview) {
                                                    e.target.style.borderColor = '#23085a';
                                                    e.target.style.boxShadow = '0 0 0 3px rgba(0, 92, 185, 0.1)';
                                                }
                                            }}
                                            onBlur={(e) => {
                                                e.target.style.borderColor = '#d0d7de';
                                                e.target.style.boxShadow = 'none';
                                            }}
                                        >
                                            {data && [{ id: '', vanbanphanhoi: '' }, ...data.lstdapan]
                                                .filter(item => isExample ? true : (item.is_example != 1))
                                                .map((item, index) => (
                                                <option key={index} value={item.id}>
                                                    {item.vanbanphanhoi || ''}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: he.decode(parts[1] || '').replace(/<\/?p[^>]*>/gi, '')
                                        }}
                                    />
                                </div>
                            </div>
                        </div>

                        {showResultTick && (
                            <div style={{ marginTop: '12px', fontSize: '22px', fontWeight: 700 }}>
                                <span style={{ color: isSelectedCorrect ? '#16a34a' : '#dc2626' }}>
                                    {isSelectedCorrect ? '✓' : '✗'}
                                </span>
                            </div>
                        )}

                        {
                            data.vanbangiaithich && overview &&
                            <div style={{
                                marginTop: '16px',
                                padding: '14px 18px',
                                backgroundColor: '#e7f3ff',
                                border: '1px solid #b3d9ff',
                                borderRadius: '10px',
                                borderLeft: '4px solid #23085a'
                            }}>
                                <div style={{
                                    color: '#23085a',
                                    fontWeight: '600',
                                    fontSize: '15px',
                                    marginBottom: '8px'
                                }}>
                                    Giải thích:
                                </div>
                                <div
                                    style={{
                                        color: '#333',
                                        fontSize: '14px',
                                        lineHeight: '1.7'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: data.vanbangiaithich }}
                                />
                            </div>
                        }
                    </>


                    :
                    <>
                        {/* <div style={{ marginBottom: '16px' }}>
                            {data.file && data.file.includes('.mp3') &&
                                <div style={{
                                    padding: '12px',
                                    backgroundColor: '#fff',
                                    borderRadius: '10px',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                                }}>
                                    <audio
                                        controlsList="nodownload"
                                        key={data.id}
                                        ref={audioRef}
                                        style={{ display: 'none' }}
                                        onEnded={() => setIsPlaying(false)}
                                    >
                                        <source src={data.file} type="audio/ogg" />
                                        <source src={data.file} type="audio/mpeg" />
                                    </audio>
                                    <button
                                        type="button"
                                        className="btn-audio-toggle"
                                        onClick={toggleAudio}
                                    >
                                        <span className="icon">{isPlaying ? '⏸' : '⏵'}</span>
                                        <span className="text">
                                            <u>{isPlaying ? 'Stop' : 'Play'}</u>
                                        </span>
                                    </button>
                                </div>
                            }
                        </div> */}
                        <div className="d-flex mt-3" style={{ justifyContent: 'end', marginRight: '10%' }}>
                            <div className="mr-3" style={{
                                padding: '16px 20px',
                                backgroundColor: '#fff',
                                // borderRadius: '10px',
                                // border: '1px solid #e0e0e0',
                                // boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                                flex: 1,
                                maxWidth: '80%'
                            }}>
                                <div
                                    style={{
                                        fontSize: '15px',
                                        lineHeight: '1.7',
                                        color: '#333',
                                        marginBottom: '12px',
                                    }}
                                >
                                    {isExample && (
                                        <span style={{
                                            display: 'inline-block',
                                            padding: '2px 10px',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffc107',
                                            borderRadius: '6px',
                                            fontSize: '13px',
                                            fontWeight: '600',
                                            color: '#856404',
                                            marginRight: '8px',
                                            verticalAlign: 'middle'
                                        }}>
                                            ⚡ Example
                                        </span>
                                    )}
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: data.vanbancauhoi.includes("_")
                                                ? he.decode(data.vanbancauhoi)
                                                : he.decode(data.vanbancauhoi)
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ minWidth: '200px' }}>
                                <div>
                                    <select
                                        style={{
                                            cursor: isExample ? 'not-allowed' : (!overview ? "pointer" : "default"),
                                            padding: '10px 14px',
                                            marginLeft: '4px',
                                            border: isExample ? '2px solid #f59e0b' : '2px solid #d0d7de',
                                            borderRadius: '8px',
                                            backgroundColor: isExample ? '#fef3c7' : '#fff',
                                            fontSize: '14px',
                                            color: isExample ? '#92400e' : '#333',
                                            fontWeight: isExample ? '700' : '500',
                                            outline: 'none',
                                            transition: 'all 0.2s ease',
                                            width: '100%',
                                            // boxShadow: overview ? 'none' : '0 2px 4px rgba(0,0,0,0.05)'
                                        }}
                                        value={selectedValue}
                                        onChange={handleChange}
                                        disabled={overview || isExample}
                                        onFocus={(e) => {
                                            if (!overview) {
                                                e.target.style.borderColor = '#23085a';
                                                e.target.style.boxShadow = '0 0 0 3px rgba(0, 92, 185, 0.1)';
                                            }
                                        }}
                                        onBlur={(e) => {
                                            e.target.style.borderColor = '#d0d7de';
                                            e.target.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
                                        }}
                                    >
                                        {data && [{ id: '', vanbanphanhoi: '' }, ...data.lstdapan]
                                            .filter(item => isExample ? true : (item.is_example != 1))
                                            .map((item, index) => {
                                            return (
                                                <option key={index} value={item.id}>
                                                    {item.vanbanphanhoi || ''}
                                                </option>
                                            )
                                        })}
                                    </select>
                                </div>

                                {showResultTick && (
                                    <div style={{ marginTop: '12px', fontSize: '22px', fontWeight: 700 }}>
                                        <span style={{ color: isSelectedCorrect ? '#16a34a' : '#dc2626' }}>
                                            {isSelectedCorrect ? '✓' : '✗'}
                                        </span>
                                    </div>
                                )}
                            </div>
                        </div>
                        {
                            data.vanbangiaithich && overview &&
                            <div style={{
                                marginTop: '16px',
                                padding: '14px 18px',
                                backgroundColor: '#e7f3ff',
                                border: '1px solid #b3d9ff',
                                borderRadius: '10px',
                                borderLeft: '4px solid #23085a'
                            }}>
                                <div style={{
                                    color: '#23085a',
                                    fontWeight: '600',
                                    fontSize: '15px',
                                    marginBottom: '8px'
                                }}>
                                    Giải thích:
                                </div>
                                <div
                                    style={{
                                        color: '#333',
                                        fontSize: '14px',
                                        lineHeight: '1.7'
                                    }}
                                    dangerouslySetInnerHTML={{ __html: data.vanbangiaithich }}
                                />
                            </div>
                        }
                    </>
                }

            </div>


            <Toast ref={toast} />
        </>
    );
}

export default TypeSelect;